import { LoginFormImport } from './Imports'
const { Card, Button, Form, InputGroup, useFormik, ForgetPasswordSchema, LuUser2, Logo } = LoginFormImport

export default function ForgetPasswordForm(props) {

    const { setTogggle } = props

    const initialValues = {
        user: '',
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: ForgetPasswordSchema,

        onSubmit: (values, action) => {
            // console.log(values)
        },
    })

    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className='h-100'>
                <Card className="h-100 rounded-start-5 rounded-end-0" style={{ backgroundColor: '#F8FAFC' }}>
                    <Card.Header className="p-3 text-end" style={{ backgroundColor: 'unset' }}>
                        <span className='fs-6 fw-medium'>Already have an account ? <u style={{ color: '#21263c', cursor: 'pointer' }} onClick={() => setTogggle(false)}> Sign In </u></span>
                    </Card.Header>
                    <Card.Body className='p-5 d-flex align-items-center'>
                        <div className='flex-fill'>
                            <img src={Logo} alt="logo" className='img-fluid' style={{ height: '100px' }} />
                            <div className='mt-3'>
                                <h3>Forget Password</h3>
                                <p>Let's get started !!...</p>
                            </div>

                            <div className='mb-2'>
                                <Form.Label className='fw-medium mb-1' style={{ color: '#001529' }}>{'Username'}</Form.Label>
                                <InputGroup className="" size="sm">
                                    <InputGroup.Text id="basic-addon1"><LuUser2 /></InputGroup.Text>
                                    <Form.Control
                                        className='login-input'
                                        placeholder="Enter Your Username"
                                        aria-label="Username"
                                        aria-describedby="basic-addon1"
                                        name='user'
                                        value={values.user || ''}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                </InputGroup>
                                {errors.user && touched.user ? (<span className='field_error'>{errors.user}</span>) : null}
                            </div>
                        </div>
                    </Card.Body>
                    <Card.Footer className="text-end" style={{ backgroundColor: 'unset' }}>
                        <Button type='submit' size='sm' className='login_save_btn'>Reset</Button>
                    </Card.Footer>
                </Card>
            </Form>
        </>
    )
}